import React, { useState } from "react";
import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import { IconPlus, IconUpload } from "@tabler/icons-react";
import { ACCEPTED_ATTENDANCE_FILES } from "utils/attendance";

const AttendanceInteractionForm = ({ attendanceId, onCreated }) => {
  const [description, setDescription] = useState("");
  const [files, setFiles] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);

  const handleSave = async () => {
    setError("");
    if (!description.trim()) {
      setError("Informe a descrição da interação.");
      return;
    }
    const data = new FormData();
    data.append("description", description.trim());
    files.forEach((file) => data.append("files", file));
    setSaving(true);
    try {
      const response = await fetch(`/backend/attendances/${attendanceId}/interactions/`, {
        method: "POST",
        body: data,
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        throw new Error(
          payload.detail ||
            payload.description?.[0] ||
            payload.files?.[0] ||
            payload.error ||
            "Não foi possível salvar a interação."
        );
      }
      setDescription("");
      setFiles([]);
      setOpen(false);
      onCreated(payload);
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (!open) {
    return (
      <Box sx={{ mt: 2 }}>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<IconPlus stroke={1.5} size="1.1rem" />}
          onClick={() => setOpen(true)}
        >
          Nova interação
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 2, p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1.5 }}>
        Nova interação
      </Typography>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <TextField
        label="Descrição *"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        multiline
        minRows={3}
        fullWidth
      />
      <Box sx={{ mt: 1.5, mb: 2 }}>
        <Button variant="outlined" component="label" size="small" startIcon={<IconUpload stroke={1.5} size="1rem" />}>
          Anexar documentos
          <input
            type="file"
            hidden
            multiple
            accept={ACCEPTED_ATTENDANCE_FILES}
            onChange={(e) => setFiles(Array.from(e.target.files || []))}
          />
        </Button>
        {files.length > 0 && (
          <Typography variant="caption" display="block" sx={{ mt: 1 }}>
            {files.map((file) => file.name).join(", ")}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button color="secondary" onClick={() => setOpen(false)} disabled={saving}>
          Cancelar
        </Button>
        <Button color="primary" variant="contained" onClick={handleSave} disabled={saving}>
          {saving ? "Salvando..." : "Salvar"}
        </Button>
      </Box>
    </Box>
  );
};

export default AttendanceInteractionForm;
